import { useDispatch } from "react-redux";
import { useCallback } from "react";
import {
  clearingCodesMasterApi,
  ClearingCodeMasterRecord,
} from "../API/getClearingCodesMaster";
import {
  IFilterDropdown,
  saveClearingCodesMasterData,
} from "../AppState/overagesFilterFormActions";

/**
 * Custom hook for managing clearing codes master data.
 *
 * Fetches clearing codes from `/master/clearing-codes`, maps them to dropdown options,
 * and stores them in Redux.
 */
export const useClearingCodesMaster = () => {
  const dispatch = useDispatch();

  const loadClearingCodes = useCallback(async () => {
    try {
      const records = await clearingCodesMasterApi();

      const options: IFilterDropdown[] = records
        .map((record: ClearingCodeMasterRecord) => ({
          actualValue: record.clearingCode,
          displayValue: `${record.clearingCode} - ${record.clearingCodeFullForm}`,
          code: record.clearingCode,
        }))
        .sort((a, b) => a.displayValue.localeCompare(b.displayValue));

      dispatch(saveClearingCodesMasterData(options));
    } catch (error) {
      console.error("Error loading clearing codes:", error);
    }
  }, [dispatch]);

  return {
    loadClearingCodes,
  };
};
